<mat-dialog-content>
  <p mat-dialog-title class="title">{{title}}</p>
  <p mat-dialog-content class="description">{{description}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="cancel" mat-dialog-close>{{'button.cancel'|translate}}</button>
  <button class="accept" [mat-dialog-close]="true" cdkFocusInitial>{{'button.accept'|translate}}</button>
</mat-dialog-actions>